<template>
  <div class="container-fluid" style="max-width: 1600px">
    <div class="row align-items-center text-black mb-3 mt-5">
      <div class="col-auto" v-for="radar in radars" @click="selectedRadars = radar.id" :key="radar.id">
        <div class="menu" :class="{ 'active': selectedRadars === radar.id }">
          {{ radar.name }}
        </div>
      </div>

      <div class="col-12 col-sm mb-3 mb-sm-0 order-first order-sm-last text-center text-sm-end">
        <img class="img-fluid" src="../assets/image/logo_StockRadars(black).png" style="height: 40px;"/>
      </div>
    </div>

    <carousel :autoplay="true" :mouse-drag="true" :loop="false" class="mb-3"
              :perPageCustom="[[640, 2], [768, 4], [1024, 5], [1280, 6], [1360, 8]]" :paginationEnabled="false">

      <slide v-for="stock in results" :key="stock.symbol">
        <div class="px-1">
          <a :href="`https://stockradars.co/search/stock/${stock.symbol}`" target="_blank">
            <div class="stock-box rounded" v-bind:class="stock.percent_change | getColorByPercentChange">
              <div class="d-flex justify-content-between small">
                <div> {{ stock.change | formatNumberWithMark(2) }}</div>
                <div> {{ stock.percent_change | formatNumberWithMark(2) }}%</div>
              </div>

              <div class="text-center">
                <div class="name">
                  {{ stock.symbol }}
                </div>
                <div class="price"> {{ stock.price | formatNumber(2) }}</div>
              </div>
            </div>
          </a>
        </div>

      </slide>
    </carousel>

    <div class="row text-black">
      <div class="col text-end">
        <div class="text-date">As of {{ date | date }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import Menu from "../components/Menu";
import {mapState} from 'vuex';
import store from '../store'
import {GET_RADARS_RESULT, GET_STOCK_INFO} from "@/store/actions.type";
import {Carousel, Slide} from 'vue-carousel';
import {getPullDXS} from "@/services/realtime";
import * as _ from 'underscore'

export default {
  name: 'screen',
  components: {Menu, Carousel, Slide},
  computed: {
    ...mapState({
      securities: state => state.securities.data,
    })
  },
  data() {
    return {
      selectedRadars: 100160,
      radars: [
        {
          id: 100160,
          name: "5m Price Gainers"
        },
        {
          id: 140,
          name: "New 52 Week High"
        }
      ],
      results: [],
      date: "",
    }
  },

  async created() {
    await this.getRadarsResult(this.selectedRadars);

    // interval pull 5 min
    setInterval(() => {
      this.getRadarsResult(this.selectedRadars);
    }, 5 * 60 * 1000)
  },
  methods: {
    async getRadarsResult(id) {
      let response = await store.dispatch(GET_RADARS_RESULT, id);
      this.date = response.last_update
      console.log(this.date);

      this.results = [];
      if (response.data) {
        response.data.map(async result => {
          let stock = await store.dispatch(GET_STOCK_INFO, result);
          if (stock) {
            this.results.push(stock);
          }
        });
      }

      let stocks = (response.data.filter((e) => e.indexOf('.') === -1));
      let stocksChunk = _.chunk(stocks, 20);
      if (stocksChunk.length > 0) {
        // chunk stock
        stocksChunk.map(stocks => {
          let data = stocks.join('|');
          // update stock
          if (data) {
            getPullDXS(data).then(stock => {
              stock.list.map(async result => {
                let stock = await store.dispatch(GET_STOCK_INFO, `${result.sym}`);
                stock ? stock.updateStockDetail(result) : "";
              })
            });
          }
        })
      }
    },
  },
  watch: {
    'selectedRadars': {
      handler: function () {
        this.getRadarsResult(this.selectedRadars);
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
.text-box {
  background-color: #497814;
  // border: 1px solid white;
  border-radius: 15px;
  margin: 6px
}

a {
  color: white;
  text-decoration: none;
}

a :hover {
  color: white;
}

.text-date {
  font-size: 13px;
  color: #686868;
}
</style>
